<template>
    <div class="times">
        <h3>Hours Coding This Week</h3>
        <p>* I found out the hard-way that if I leave my IDE on, a background process will trick my timer into thinking I worked 24 hours.  oops</p>
        <div>
            <div class="table-meter time-bar">
                <div class="segment" v-for="(hour, index) in calcMaxHours()"
                     :key="index"
                    :style="{width:segmentPercentage}">{{index}}hr</div>
            </div>
            <div class="day-meter" v-for="(time, index) in timeThis" :key="index">
                <div class="time-bar">
                    <div class="progress-meter desktop" :class="calculateMinutes(time) < 20 ? 'hide': ''" :style="{'width': calculateMinutes(time) + '%'}">
                        <div class="label" v-text="getDay(time)"></div>
                        <div class="time-calc" :class="(calculateMinutes(time) < 25) ? 'pop-hours':''" v-text="getTimeCalc(time)"></div>
                    </div>

                    <div class="progress-meter mobile" :class="calculateMinutes(time) < 20 ? 'hide': ''">
                        <div class="label" v-text="getDay(time)"></div>
                        <div class="time-calc" v-text="getTimeCalc(time)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import jsonp from 'jsonp';

    // https://wakatime.com/share/@b72ba8cd-6de5-40e6-bead-a9fe96627675/62246206-869e-4997-93d8-79053aeb44db.json
    let url = 'api/share/@b72ba8cd-6de5-40e6-bead-a9fe96627675/62246206-869e-4997-93d8-79053aeb44db.json?ran=' + (Math.floor(Math.random() * 100));

    export default {
        name: 'waka-times',
        beforeMount() {
            let wakaTimesAPICall = new Promise((resolve, reject) => {
                jsonp(url, null, function (err, response) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(response.data);
                    }
                });
            });
            wakaTimesAPICall.then((message) => {
                var arr = message;
                let totalMinutes = 0;
                for (let i = 0; i < message.length; i ++) {
                    let hours = message[i].grand_total.hours * 60;
                    let minutes = message[i].grand_total.minutes;
                    totalMinutes = totalMinutes + hours + minutes;
                }
                /* set into sesh */
                sessionStorage.setItem('totalMinutes', totalMinutes);

                arr = arr.splice(0, message.length -1);
                arr = arr.reverse();
                // console.log(arr);
                this.timeThis = arr;
            }).catch((message) => {
                console.error('Issue with waka times API call. ', message);
                this.timeThis = [];
            });
        },
        methods: {
            calcMaxHours: function() {
                let maxHours = 0;
                for (let i = 0; i < this.timeThis.length; i++) {
                    let tempMax = (this.timeThis[i].grand_total.hours + 1);
                    if( tempMax > maxHours) {
                        maxHours = tempMax +1;
                    }
                }
                this.segmentPercentage = (100 / maxHours) + '%';
                this.maxHours = maxHours;
                return maxHours;
            },
            calculateMinutes: function(time) {
                let maxTime = this.maxHours*60;
                let minutes = time.grand_total.hours * 60 + time.grand_total.minutes;
                return Math.ceil(minutes/maxTime * 100);
            },
            getDay: function (dateValue) {
                var dayString = dateValue.range.text;

                let day;
                if(dayString !== 'Yesterday') {
                    day = this.days[dayString.split(' ')[0]];
                } else {
                    day = dayString;
                }

                let betterDate = dateValue.range.date.split('-');
                dayString = betterDate[0].substr(2,2);
                let activityDay = betterDate[1] + '.' +betterDate[2] + '.' +  dayString;
                return day  +' '+ activityDay;
            },
            getTimeCalc: function (dateValue) {
                let timeString = dateValue.grand_total.hours + 'h ' + dateValue.grand_total.minutes + 'm';
                return timeString;
            }
        },
        data: function () {
            return {
                maxHours: 0,
                segmentPercentage:0,
                days: {
                    Mon:'Monday',
                    Tue:'Tuesday',
                    Wed:'Wednesday',
                    Thu:'Thursday',
                    Fri:'Friday',
                    Sat:'Saturday',
                    Sun:'Sunday'
                },
                timeThis: []
            };
        }
    }
</script>
